import React, {useEffect, useState} from 'react'
import ClientInfo from "./components/ClientInfo/ClientInfo";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import clientInfoActions from "../../store/clientInfoStore/clientInfoActions";
import clientsActions from "../../store/clientsStore/clientsActions";
import branchReducer from "../../store/branchStore/branchReducer";
import bonusesModalReducer from "../../store/bonusesModalStore/bonusesModalReducer";
import {ERROR, SUCCESS} from "../../store/globalStatuses/globalStatuses";
import debounce from "../../tools/debounce";
import Modal from "react-modal";
import styles from "../Clients/Clients.module.scss";
import closeModalImage from "../../components/PayModal/assets/CloseModalIcon.svg";
import ButtonFilled from "../../components/FormElements/ButtonFilled";
import {useCurrentBranch} from "../../hooks/useCurrentBranch";

export default function ClientInfoContainer() {
    const {id} = useParams()
    const [branchInfo, setBranchInfo] = useState(null)
    const params = Object.fromEntries(new URLSearchParams(location.search));
    const { currentRole } = useCurrentBranch()
    const {customer, cStatus, tStatus, page} = useSelector(state => state.clientInfoReducer)
    const {
        status,
    } = useSelector(s => s.clientsReducer);
    const {payment_status} = useSelector(state => state.bonusesModalReducer)
    const {info} = useSelector(state => state.branchReducer)
    const dispatch = useDispatch()
    const history = useHistory()

    useEffect(() => {
        if (!branchInfo && info) setBranchInfo(info)
    }, [info]);

    useEffect(() => {
        if (payment_status === SUCCESS || payment_status === '' || payment_status === ERROR) {
            dispatch(clientInfoActions.getClientInfo(id, branchInfo, currentRole, params))
        }

        return () => {
            dispatch(clientInfoActions.resetClientInfo())
        }
    }, [branchInfo, payment_status])

    useEffect(() => {
        if (payment_status === SUCCESS || payment_status === '' || payment_status === ERROR) {
            debounce(() => dispatch(clientInfoActions.getClientTransactions(id, page, branchInfo)), 100)
        }
    }, [page, branchInfo, payment_status])

    const getBackToClients = () => {
        history.goBack()
    }


    return (
      <>
          <ClientInfo
            customer={customer}
            cStatus={cStatus}
            tStatus={tStatus}
            getBackToClients={getBackToClients}
            status={status}
            info={info}
          />
      </>
    )
}
